import React, { useEffect } from "react";
import "./TermsConditionsBottomSheet.css";

const TermsConditionsBottomSheet = ({ isOpen, onClose }) => {
  // Prevent scrolling on body when bottom sheet is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <>
      <div
        className={`terms-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      ></div>
      <div className={`terms-bottom-sheet ${isOpen ? "show" : ""}`}>
        <div className="terms-sheet-header">
          <div className="terms-drag-handle" onClick={onClose}></div>
          <button className="terms-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="terms-sheet-content">
          <div className="terms-header-section">
            <h1 className="terms-title terms-font-heading">Terms of Service</h1>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">OVERVIEW</h3>
            <p>
              This website is operated by Aaroh Foods. Throughout the site, the
              terms “we”, “us” and “our” refer to Aaroh Foods. Aaroh Foods
              offers this website, including all information, tools and services
              available from this site to you, the user, conditioned upon your
              acceptance of all terms, conditions, policies and notices stated
              here.
            </p>
            <p>
              By visiting our site and/ or purchasing something from us, you
              engage in our “Service” and agree to be bound by the following
              terms and conditions (“Terms of Service”, “Terms”), including
              those additional terms and conditions and policies referenced
              herein and/or available by hyperlink. These Terms of Service apply
              to all users of the site, including without limitation users who
              are browsers, vendors, customers, merchants, and/ or contributors
              of content.
            </p>
            <p>
              Please read these Terms of Service carefully before accessing or
              using our website. By accessing or using any part of the site, you
              agree to be bound by these Terms of Service. If you do not agree
              to all the terms and conditions of this agreement, then you may
              not access the website or use any services. If these Terms of
              Service are considered an offer, acceptance is expressly limited
              to these Terms of Service.
            </p>
            <p>
              This website is operated by Aaroh Food Ltd. Throughout these
              terms, “we”, “us”, and “our” refer to Aaroh Food Ltd. We provide
              this website, along with all information, tools, and services
              available through it, on the condition that you accept all terms,
              conditions, policies, and notices outlined here. By visiting our
              website or shopping with us—whether online or in-store—you agree
              to be bound by these Terms of Service (“Terms”). These Terms apply
              to all users, including shoppers, browsers, suppliers, vendors,
              and contributors of content. Please read these Terms carefully
              before using our website. If you do not agree with any part of the
              Terms, you may not access the website or use our services. We may
              update these Terms at any time by posting changes on this page.
              Continued use of the site indicates acceptance of any revisions.
              Our online store is hosted through an e-commerce platform that
              allows us to offer groceries and household essentials for
              sale.{" "}
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 1 - ONLINE STORE TERMS
            </h3>
            <p>
              By using our online store, you confirm that you are at least the
              age of majority in your country of residence or have given consent
              for your minor dependents to use our website.
            </p>
            <p>
              You may not use our products for any unlawful purpose, nor may you
              violate local laws during your use of our service.
            </p>
            <p>
              Any misuse such as transmitting harmful code (viruses, malware,
              etc.) will result in immediate termination of service..
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 2 - GENERAL CONDITIONS
            </h3>
            <p>
              We reserve the right to refuse service to anyone for any reason at
              any time.
            </p>
            <p>
              You understand that your content (not including credit card
              information), may be transferred unencrypted and involve (a)
              transmissions over various networks; and (b) changes to conform
              and adapt to technical requirements of connecting networks or
              devices. Credit card information is always encrypted during
              transfer over networks.
            </p>
            <p>
              You agree not to reproduce, duplicate, copy, sell, resell or
              exploit any portion of the Service, use of the Service, or access
              to the Service or any contact on the website through which the
              service is provided, without express written permission by us.
            </p>
            <p>
              The headings used in this agreement are included for convenience
              only and will not limit or otherwise affect these Terms.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION
            </h3>
            <p>
              While we work to ensure accuracy, we are not responsible if information on our site is outdated, 
incomplete, or inaccurate. The content is provided for general use only. 
            </p>
            <p>
              Relying solely on the content on this website is at your own risk. 
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES
            </h3>
            <p>Product prices may change without notice.</p>
            <p>
              We may modify or discontinue any part of our service at any time without liability. 
            </p>
            
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 5 - PRODUCTS OR SERVICES (if applicable)
            </h3>
            <p>
             Some items may only be available online and may have limited quantities. Returns and exchanges 
follow our Return Policy. 
            </p>
            <p>
             We aim to display product images and colours accurately but cannot guarantee your screen’s 
accuracy.
            </p>
            <p>
          We may limit product sales by region, customer type, or quantity. 
            </p>
           .
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION
            </h3>
            <p>
             We may refuse or limit any order you place. 
            </p>
            <p>
              You must provide accurate, complete and current account details for all purchases. 
            </p>
            <p>For more detail, please review our Returns Policy.</p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">SECTION 7 - OPTIONAL TOOLS</h3>
            <p>
              We may offer access to third-party tools that we do not monitor or control. Use them at your own 
discretion. 
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 8 - THIRD-PARTY LINKS
            </h3>
            <p>
              Certain products, services, or content may link to third-party websites. We are not responsible for 
those sites. 
            </p>
            
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS
            </h3>
                      <p>
                          Any comments, suggestions, or ideas you submit—whether requested or not—may be used by us 
freely without compensation. 
            </p>
           
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 10 - PERSONAL INFORMATION
            </h3>
            <p>
             Your personal information is handled according to our Privacy Policy. 
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS
            </h3>
            <p>
              Occasionally, our website may contain inaccuracies relating to product descriptions, pricing, 
promotions, or availability. We reserve the right to correct these at any time.
            </p>
           
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">SECTION 12 - PROHIBITED USES</h3>
            <p>
             You may not use our website to: 
● Break any law 
● Harass or harm others 
● Upload malicious code 
● Collect personal data without consent 
● Engage in fraudulent activity 
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY
            </h3>
            <p>
            We do not guarantee uninterrupted, secure, or error-free service. Use of our service is at your own 
risk. 
            </p>
            <p>
            We are not liable for any loss, damage, or interruption arising from use of the site or products. 
            </p>
           
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">SECTION 14 - INDEMNIFICATION</h3>
            <p>
             You agree to indemnify and hold harmless Aaroh Food Ltd from any claims arising from your breach 
of these Terms. 
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">SECTION 15 - SEVERABILITY</h3>
            <p>
              If any part of these Terms is ruled invalid, the rest remains enforceable.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">SECTION 16 - TERMINATION</h3>
            <p>
            These Terms remain in effect until terminated by you or us. You may stop using our services at any 
time.
            
            </p>
           
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 17 - ENTIRE AGREEMENT
            </h3>
            <p>
             These Terms form the full agreement between you and Aaroh Food Ltd regarding website use.
            </p>
           
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">SECTION 18 - GOVERNING LAW</h3>
            <p>
             These Terms are governed by the laws of the United Kingdom.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 19 - CHANGES TO TERMS OF SERVICE
            </h3>
            <p>
             We reserve the right to revise these Terms at any time. Check this page regularly. 
            </p>
           
          </div>

          <div className="terms-section">
            <h3 className="terms-font-heading">
              SECTION 20 - CONTACT INFORMATION
            </h3>
            <p>
              Questions about the Terms of Service should be sent to us at
              aarohfood@gmail.com.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditionsBottomSheet;
